<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="products"
    :search="search"
    @dblclick:row="handleClickRow"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <alert
        :visible="!!error"
        type="error"
        :message="error"
        :clickClose="() => (error = '')"
      />
      <v-toolbar flat>
        <v-toolbar-title>PRODUTOS IMPORTADOS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <!-- <v-btn color="" class="mr-2" dark to="/importar-produto">
          <v-icon class="mr-2">mdi-file-code-outline</v-icon>
          Importar XML
        </v-btn>
        <v-btn color="blue darken-1" dark to="/produto/novo">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn> -->
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Modal de Duplicar -->
        <v-dialog v-model="dialogDuplicate" max-width="500px">
          <v-card>
            <v-toolbar color="orange lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Duplicar esse Produto?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDuplicate"
                >Fechar</v-btn
              >
              <v-btn color="orange darken-1" dark @click="duplicateItemConfirm">
                <v-icon dark>mdi-content-duplicate</v-icon>
                Duplicar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.company.name="{ item }">
      {{ getNameCompany(item) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.reference="{ item }">
      {{ getFullReference(item) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ dateFormat(item.created_at) }}
    </template>
    <!-- eslint-disable-next-line -->
    <!-- <template v-slot:item.updated_at="{ item }">
      {{ (item.updated_at) }}
    </template> -->
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="green darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="green darken-1"
            @click="viewItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-file
          </v-icon>
        </template>
        <span>Visualizar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { URL, BASE_URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    dialogDelete: false,
    dialogDuplicate: false,
    search: "",
    loading: false,
    error: false,
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 50,
      },
      { text: "Referência", value: "reference", width: 80 },
      { text: "Nome", value: "name", width: 160 },
      // { text: "Fornecedor", value: "company.name", width: 160 },
      { text: "Rede", value: "price_cif", width: 60, align: "right" },
      { text: "Multimarcas", value: "price_mult", width: 60, align: "right" },
      { text: "Cadastro", value: "created_at", width: 60, align: "left" },
      { text: "Status", value: "status", width: 60, align: "left" },
      // { text: "Atualização", value: "updated_at", width: 90, align: "left" },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    products: [],
    editedItem: {
      name: "",
      status: 1,
    },
    editedItemDuplicate: {
      name: "",
      status: 1,
    },
    defaultItem: {
      name: "",
      status: 1,
    },
    dialogQrCode: false,
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogDuplicate(val) {
      val || this.closeDuplicate();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getProducts();
    },
    getColor() {
      return "blue";
      // return status == 1 ? "green" : "red";
    },
    getLabel() {
      return "Aguardando aprovação";
      // return status == 1 ? "Ativo" : "Desativado";
    },
    getNameCompany(item) {
      return `${item.company.code} - ${item.company.name}`;
    },
    getFullReference(item) {
      return `${item.company.code}${item.reference}`;
    },

    async getProducts() {
      this.loading = true;
      this.products = [];
      try {
        let res = await fetch(`${URL}product?provider_id=18`);
        this.products = await res.json();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({
        name: "ProductViewImport",
        params: { id: item.id, grid: item },
      });
    },
    viewItem(item) {
      this.$router.push({
        name: "ProductViewImport",
        params: { id: item.id },
      });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    duplicateItem(item) {
      this.editedItemDuplicate = Object.assign({}, item);
      this.dialogDuplicate = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.products = [];
      try {
        let res = await fetch(`${URL}product/${this.editedItem.id}`, {
          method: "DELETE",
        });
        if (res.ok) {
          this.loading = false;
          this.initialize();
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.closeDelete();
    },
    async duplicateItemConfirm() {
      this.loading = true;
      try {
        let res = await fetch(
          `${URL}product/${this.editedItemDuplicate.id}/duplicate`,
          {
            method: "POST",
          }
        );
        if (res.ok) {
          this.loading = false;
          let response = await res.json();
          console.log(response);
          if (typeof response.error !== "undefined") {
            throw new Error(response.message);
          } else {
            this.products = [];
            this.initialize();
          }
        }
      } catch (error) {
        this.loading = false;
        this.error = error.message;
        console.log(error);
      }
      this.closeDuplicate();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    closeDuplicate() {
      this.dialogDuplicate = false;
      this.$nextTick(() => {
        this.editedItemDuplicate = Object.assign({}, this.defaultItem);
      });
    },
    dateFormat(date) {
      if (date === "" || date === null) {
        return "";
      }
      return date.substring(0, 10);
    },
    handleClickRow(event, item) {
      console.log(event);
      this.editItem(item.item);
    },
    openQrCodeDialog(item) {
      // console.log(item);
      item.attributes.map((attr) =>
        console.log(attr.material.name, attr.color.name)
      );
      // console.log(item.attributes[0]);
    },
    linkOpenTag(item) {
      console.log(item.id);
      return `${BASE_URL}etiqueta/${item.id}`;
    },
  },
};
</script>
